import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getCoinBalance, isCreatedGauge } from "../../libs/aptos_sdk";
import { getCoinInfo, CoinInfo, getPool } from "../../libs/pool";
import {
  get_coin_icon,
  get_coin_address_by_pair,
  get_coin_xy_supply,
  get_lp_coin_balance_no_decimals,
  getDecimalsAmount,
} from "../../libs/swap_sdk";
import { useAppSelector } from "../../store/hooks";
import Button from "../Common/Button";
interface PairRowProps {
  pair: any;
  create_gauge: Function;
}

const PairRow: React.FC<PairRowProps> = ({ pair, create_gauge }) => {
  const navigate = useNavigate();
  const [walletAmountX, setWalletAmountX] = useState<number>(0);
  const [walletAmountY, setWalletAmountY] = useState<number>(0);

  const [myPoolX, setMyPoolX] = useState<number>(0);
  const [myPoolY, setMyPoolY] = useState<number>(0);

  const [poolX, setPoolX] = useState<number>(0);
  const [poolY, setPoolY] = useState<number>(0);

  const [coinX, coinY] = get_coin_address_by_pair(pair.type);

  const coinInfoIconX = get_coin_icon(coinX);
  const coinInfoIconY = get_coin_icon(coinY);

  const [xCoinInfo, setXCoinInfo] = useState<CoinInfo | undefined>(undefined);
  const [yCoinInfo, setYCoinInfo] = useState<CoinInfo | undefined>(undefined);
  const [createdGauge, setCreatedGauge] = useState<boolean>(true);

  useEffect(() => {
    const getIsCreatedGauge = async () => {
      if (xCoinInfo && yCoinInfo) {
        setCreatedGauge(
          await isCreatedGauge(xCoinInfo.address, yCoinInfo.address)
        );
      }
    };
    getIsCreatedGauge();
  }, [xCoinInfo, yCoinInfo]);

  useEffect(() => {
    getCoinInfo(coinX).then((res) => {
      setXCoinInfo(res);
    });
  }, [coinX]);

  useEffect(() => {
    getCoinInfo(coinY).then((res) => {
      setYCoinInfo(res);
    });
  }, [coinY]);

  const accountAddress = useAppSelector(
    (state: any) => state.wallet.accountAddress
  );

  useEffect(() => {
    const get = async () => {
      const x = await getCoinBalance(accountAddress, coinX);
      const y = await getCoinBalance(accountAddress, coinY);

      // @ts-ignore
      setWalletAmountX(Number(x));

      // @ts-ignore
      setWalletAmountY(Number(y));
      const amountXY = await get_lp_coin_balance_no_decimals(
        accountAddress,
        coinX,
        coinY
      );
      // const amountXY = await get_lp_coin_balance(
      //   accountAddresses,
      //   coinX,
      //   coinY
      // );

      //lp token supply
      const coin_info_supply = await get_coin_xy_supply(coinX, coinY);
      const share = amountXY / coin_info_supply;
      const pool = await getPool(coinX, coinY);
      const myPoolX = Number(pool?.reserve_x) * share;
      const myPoolY = Number(pool?.reserve_y) * share;

      setMyPoolX(
        Number(getDecimalsAmount(myPoolX, pool?.x_coin_info.decimals))
      );
      setMyPoolY(
        Number(getDecimalsAmount(myPoolY, pool?.y_coin_info.decimals))
      );

      setPoolX(
        Number(
          getDecimalsAmount(Number(pool?.reserve_x), pool?.x_coin_info.decimals)
        )
      );
      setPoolY(
        Number(
          getDecimalsAmount(Number(pool?.reserve_y), pool?.y_coin_info.decimals)
        )
      );
    };

    if (accountAddress) {
      get();
    }
  }, [coinX, coinY, accountAddress]);

  const showValue = (
    value1: string,
    label1: string,
    value2: string,
    label2: string
  ) => {
    return (
      <div className="flex justify-center items-center pl-2 pt-1 flex-col">
        {getValueAndLabel(value1, label1)}
        {getValueAndLabel(value2, label2)}
      </div>
    );
  };

  const getValueAndLabel = (value: string, label: string) => (
    <div className="flex gap-2">
      <p className="font-semibold">{value || "0.00"}</p>

      <p>{label}</p>
    </div>
  );

  return (
    <tr>
      <td>
        <div className="flex pl-2 pt-1 gap-3">
          <div className="flex justify-center items-center ">
            <img alt="Coin" className="w-10 h-10" src={coinInfoIconX.icon} />
            <img
              alt="Coin"
              className="w-10 h-10 -ml-4"
              src={coinInfoIconY.icon}
            />
          </div>
          <div className="flex justify-center items-center ">
            <p className="font-semibold">{xCoinInfo?.symbol!}</p>-
            <p className="font-semibold">{yCoinInfo?.symbol!}</p>
          </div>
        </div>
      </td>
      <td>
        {showValue(
          walletAmountX.toFixed(3),
          xCoinInfo?.symbol!,
          walletAmountY.toFixed(3),
          yCoinInfo?.symbol!
        )}
      </td>
      <td>
        {showValue(
          myPoolX.toFixed(3),
          xCoinInfo?.symbol!,
          myPoolY.toFixed(3),
          yCoinInfo?.symbol!
        )}
      </td>
      <td>
        {showValue(
          poolX.toFixed(3),
          xCoinInfo?.symbol!,
          poolY.toFixed(3),
          yCoinInfo?.symbol!
        )}
      </td>
      <td className="p-2 flex justify-center">
        <div>
          <Button
            variant="gradient"
            className="w-32"
            onClick={() => navigate(`/pools/pair/${coinX}/${coinY}`)}
          >
            Manage
          </Button>
        </div>
        <div>
          {!createdGauge && (
            <Button
              variant="gradient"
              className="w-32"
              onClick={() => {
                create_gauge(xCoinInfo?.address, yCoinInfo?.address);
              }}
            >
              Create Gauge
            </Button>
          )}
        </div>
      </td>
    </tr>
  );
};

export default PairRow;
